<template>

<div class="main list-view">

	<div class="sub-header">
		<div class="input-with-control">
			<input type="text" ref="search_term" v-model="filters.search_term" placeholder="Search..." @keyup.enter="getList(1)" v-focus>
			<div class="button action input-go" @click="getList(1)"><i class="fas fa-search"></i></div>
		</div>
		<div class="controls">
			<pagination v-if="showPagination" :paging="paging" @updatePage="goToPage"></pagination>
		</div>
	</div>

	<div class="filters" v-if="showFilters">
		<ul class="checkbox-group">
			<li>
				<span :class="['pointer', 'far', filters.published ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('published')"></span>
				<label>Published</label>
			</li>
			<li>
				<span :class="['pointer', 'far', filters.inactive ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('inactive')"></span>
				<label>Inactive</label>
			</li>
		</ul>
		<label>Alert Type</label>
		<select v-model="filters.system_alert_type_id" @change="getList()">
			<option value="">Select...</option>
			<option v-for="(alertType, index) in systemAlertTypes" :value="alertType.system_alert_type_id">{{ alertType.description }}</option>
		</select>
		<label>For Client</label>
		<select v-model="filters.client_id" @change="toggleFilter('client_id')">
			<option value="">Select...</option>
			<option v-for="(client, index) in clients" :value="client.client_id">{{ client.company_name }} [{{ client.client_id}}]</option>
		</select>
		<div class="divider"></div>
		<div class="button neutral" @click="clearFilters(1)">Clear Filters</div>
		<div v-if="!showDetail" class="button action" @click="newItem()">New Alert</div>

		<button v-if="showDetail" class="button neutral" @click="backToList()">Back To List</button>
		<div v-if="showDetail" :class="['button', saving ? 'disabled' : 'action']" @click="saveItem()">Save Alert</div>
		<message v-if="saving" message='Saving' :loading="saving"></message>
	</div>

	<div v-if="!showDetail" class="list">

	    <div v-if="list.length == 0" class="empty-list">
	        This list is empty
	    </div>

	    <table v-else class="data-list" cellpadding="0" cellspacing="0">
			<thead>
				<tr>
					<th class="list">Alert Type</th>
					<th class="list">Title</th>
					<th class="list">Content</th>
					<th class="list">Link Label</th>
					<th class="list center">Published</th>
					<th class="list center">Client</th>
				</tr>
			</thead>
			<tr v-for="(alert, index) in list" class="clickable-list-item" @click="getItem(alert.system_alert_id)">
				<td class="list">{{ alert.system_alert_type }}</td>
				<td class="list">{{ alert.title }}</td>
				<td class="list">{{ alert.content }}</td>
				<td class="list">{{ alert.link_label }}</td>
				<td class="list center"><i v-if="alert.internal_use_only == 0" class="fas fa-check"></i></td>
				<td class="list center"><i v-if="alert.client_id > 0" class="fas fa-check"></i></td>
			</tr>
		</table>

	</div>

	<div v-if="showDetail" class="detail">
		<div class="three-columns">
			<div>
				<label>Type</label>
				<select v-model="alertDetail.system_alert_type_id">
					<option value="">Select...</option>
					<option v-for="(alertType, index) in systemAlertTypes" :value="alertType.system_alert_type_id">{{ alertType.description }}</option>
				</select>
			</div>
			<div>
				<label>For Client</label>
				<select v-model="alertDetail.client_id">
					<option value="">Select...</option>
					<option v-for="(client, index) in clients" :value="client.client_id">{{ client.company_name }} [{{ client.client_id}}]</option>
				</select>
			</div>
			<div>
				<label>Expires</label>
				<div><input type="date" v-model="alertDetail.expires" /></div>
			</div>
		</div>
		<label>Title</label>
		<input type="text" v-model="alertDetail.title" />
		<label>Content</label>
		<textarea v-model="alertDetail.content" />
		<label>Link Label</label>
		<input type="text" v-model="alertDetail.link_label" />
		<label>Link</label>
		<input type="text" v-model="alertDetail.link" />

		<label class="checkbox spaced">
			<input type="checkbox" v-model="alertDetail.published" value="1">
			<span><i class="fas fa-check-circle"></i>Published</span>
		</label>
		<label class="checkbox spaced">
			<input type="checkbox" v-model="alertDetail.inactive" value="1">
			<span><i class="fas fa-check-circle"></i>Inactive</span>
		</label>

	</div>

</div>

</template>

<script>
import Message from '@/components/Message'
export default {
	name: 'system-alerts',
    components: {
        'message': Message
    },
	data() {
		return {
            loading: true,
			page: 1,
			showPagination: false,
			showFilters: true,
			filters: {},
			list: [],
			paging: {},
			showDetail: false,
			alertDetail: {},
			clients: [],
			systemAlertTypes: [],
			saving: false,
			message: ''
		}
	},
	created() {
		this.getClientList()
		this.getSystemAlertTypes()
		this.clearFilters(true)
	},
	methods: {
		getClientList() {
            this.apiCall({ destination: 'get_list_clients_full_list' }).then(obj => {
                this.clients = obj.clients
            }).catch(err => {
                console.log(err);
            })
		},
		getSystemAlertTypes() {
			this.apiCall({ destination: 'get_list_system_alert_types', data: this.filters }).then(obj => {
				this.systemAlertTypes = obj.system_alert_types
			}).catch(err => {
				console.log(err)
			})
		},
		clearFilters(getList) {
			this.filters = {
				page: 1,
				search_term: '',
				internal_use_only: '',
				inactive: '',
				system_alert_type_id: '',
				client_id: ''
			}
			if (getList) {
				this.getList()
			}
		},
		toggleFilter(which) {
			if (which != 'client_id') {
				this.filters[which] = !this.filters[which]
			}
			this.filters.page = 1
			this.getList()
		},
		getList(page) {
			this.showDetail = false
			this.loading = true
			this.apiCall({ destination: 'get_list_system_alerts', data: this.filters }).then(obj => {
				this.loading = false
				this.list = obj.list
				this.paging = obj.paging
			}).catch(err => {
				console.log(err)
			})
		},
		goToPage(page) {
			this.filters.page = page
			this.getList()
		},
		getItem(alertId) {
			this.loading = true
			this.apiCall({ destination: 'get_item_system_alert', data: { system_alert_id: alertId } }).then(obj => {
				this.alertDetail = obj.system_alert
				this.alertDetail.published = this.alertDetail.internal_use_only ? 0 : 1
				this.loading = false
				this.showPagination = false
				this.showDetail = true
			}).catch(err => {
				console.log(err)
			})
		},
		newItem() {
			this.alertDetail = {
				system_alert_type_id: '',
				client_id: ''
			}
			this.showPagination = false
			this.showDetail = true
		},
		saveItem() {
			if (this.saving) { return }
			this.saving = true
			this.apiCall({ destination: 'save_item_system_alert', data: this.alertDetail }).then(obj => {
				this.saving = false
				this.message = obj.message || 'Alert saved!'
				if (obj.status == 'success') {
					this.alertDetail.system_alert_id = obj.system_alert_id
					setTimeout(() => { this.message = '' }, 2000)
				}
			}).catch(err => {
				console.log(err)
			})
		},
		backToList() {
			this.showDetail = false
			this.alertDetail = {}
			this.showPagination = this.paging.total_pages > 1
			this.getList()
		}
	}
}
</script>

<style lang="scss" scoped>
</style>
